import { RootState } from '../store';

const getAuthSelector = (state: RootState) => state.common.auth;
const getConfig = (state: RootState) => (state.landings as any).config;

export { getAuthSelector, getConfig };
